(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var success = document.querySelector('.contact-form__success');
    if (!success) return;
    history.replaceState(null, document.title, window.location.pathname);
    setTimeout(function () {
      success.style.transition = 'opacity 0.4s ease';
      success.style.opacity = '0';
      setTimeout(function () { success.style.display = 'none'; }, 400);
    }, 4000);
  });
  } catch(e) { console.error(e); }
})();

})();
